module.exports = __webpack_public_path__ + "media/images/menu/events-2ae381eac0db7b59b9f3c06811157e4d.jpg";